import {AppParametersConfiguration} from "./appParameters.config";
import {AssociationConfiguration} from "./association.config";
import {ChangeStatusConfiguration} from "./changeStatus.config";
import {CycleCountConfiguration} from "./cycleCount.config";
import {FindItemConfiguration} from "./findItem.config";
import {ReaderConfiguration} from "./reader.config";
import {UnassociatedConfiguration} from "./unassociated.config";
import {IdentifyItemConfiguration} from "./identifyItem.config";
import {Type} from "serializer.ts/Decorators";
import {SimulatorConfiguration} from "./simulator.config";
import {EncodeTagConfiguration} from "./encodeTag.config";
import {ReplenishmentConfiguration} from "./replenishment.config";
import {LookupConfiguration} from "./lookUp.config";


export class ConfigurationThing {

  @Type(() => AppParametersConfiguration)
  AppParametersConfiguration: AppParametersConfiguration;

  @Type(() => AssociationConfiguration)
  AssociationConfiguration: AssociationConfiguration;


  @Type(() => ChangeStatusConfiguration)
  ChangeStatusConfiguration: ChangeStatusConfiguration;

  @Type(() => CycleCountConfiguration)
  CycleCountConfiguration: CycleCountConfiguration;

  @Type(() => FindItemConfiguration)
  FindItemConfiguration: FindItemConfiguration;

  @Type(() => IdentifyItemConfiguration)
  IdentifyItemConfiguration: IdentifyItemConfiguration;

  @Type(() => ReaderConfiguration)
  ReaderConfiguration: ReaderConfiguration;

  @Type(() => UnassociatedConfiguration)
  UnassociatedConfiguration: UnassociatedConfiguration;

  @Type(() => SimulatorConfiguration)
  SimulatorConfiguration: SimulatorConfiguration;


  @Type(() => EncodeTagConfiguration)
  EncodeTagConfiguration: EncodeTagConfiguration;

  @Type(() => ReplenishmentConfiguration)
  ReplenishmentConfiguration:ReplenishmentConfiguration;

  @Type(() => LookupConfiguration)
  LookupConfiguration:LookupConfiguration;


  name:string;

  StoreID: string;

  _id: number;
}



// WEBPACK FOOTER //
// ./src/models/configurationThing.ts